import * as React from 'react';
import { styled } from '@mui/system';
import NoteCard from '../NoteCard/NoteCard';

const NotesDisplay = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: '30px',
});

const NoteCardGroup = (NoteFeedData) => {
  const NoteData = NoteFeedData.NoteFeedData;
  if (!NoteFeedData) return '';
  return (
    <NotesDisplay>
      {NoteData.map((data) => (
        <NoteCard key={data._id} props={data} />
      ))}
    </NotesDisplay>
  );
};

export default NoteCardGroup;
